import { Badge } from "@/components/Badge";
import { HStack } from "@/components/Layout";
import { defaultNS, useTranslation } from "@/lib/i18n";

export function ShadowIdBadge() {
	const { t } = useTranslation(defaultNS, {
		keyPrefix: "pages.apps.alert.shadowIt",
	});

	return (
		<Badge variant="errorMuted">
			<HStack className="items-center gap-1">
				{t("shadowId")}
			</HStack>
		</Badge>
	);
}
